import React from "react";
import TextInput from "components/TextInput";
import { certificationExportStore } from "../CertificationExportStore";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { ExportCertificationOptions } from "api-client";
import { buildingStore } from "store/Building/BuildingStore";

const ConfigureBNB = () => {
  const { t } = useTranslation();

  const { currentBuilding } = buildingStore;
  const savedValues: ExportCertificationOptions | undefined | null =
    currentBuilding?.certification_export_settings?.bnb;

  React.useEffect(() => {
    if (savedValues?.net_floor_area) {
      certificationExportStore.setAdditionalInfoFieldAndValue(
        "netFloorArea",
        String(savedValues.net_floor_area)
      );
    }
  }, []);

  return (
    <TextInput
      type="number"
      handleChange={(value) =>
        certificationExportStore.setAdditionalInfoFieldAndValue(
          "netFloorArea",
          value
        )
      }
      unit="m²"
      labelName={t("certExport.netFloorArea")}
      required
      placeholder={t("certExport.pleaseEnterArea")}
      helper={t("certExport.netFloorAreaHelper")}
      name="netFloorArea"
      value={certificationExportStore.additionalInfo.netFloorArea}
    ></TextInput>
  );
};

export default observer(ConfigureBNB);
